var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcVisaLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "20px",
    viewBox: "0 0 65 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D-10b_Emirates_ID-Copy-2",
    transform: "translate(-603.000000, -520.000000)",
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Saved-credit-card",
    transform: "translate(327.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(49.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa",
    transform: "translate(227.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "26.1514943 0.670713876 22.8660398 19.0291852 28.1188523 19.0291852 31.4065227 0.670713876"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 0.311162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1782188,0.811524402 C46.1371108,0.439452632 44.5058324,0.0406535885 42.468304,0.0406535885 C37.2760597,0.0406535885 33.6179631,2.53051005 33.5869403,6.09895263 C33.5577642,8.73686411 36.1983892,10.2086225 38.1915994,11.0867541 C40.2368835,11.9863378 40.924554,12.5602708 40.9149517,13.3638474 C40.9020256,14.5943569 39.2814574,15.1566847 37.770946,15.1566847 C35.667679,15.1566847 34.5504915,14.87851 32.8246676,14.1930962 L32.1473381,13.9012062 L31.4098097,18.0108761 C32.6374233,18.523266 34.9068835,18.9674311 37.2635028,18.99029 C42.7873949,18.99029 46.3734744,16.5289191 46.4144688,12.7181727 C46.4340426,10.6299287 45.0339574,9.04035933 42.0022244,7.73037129 C40.1656051,6.88107703 39.0406619,6.31417751 39.0524801,5.45433301 C39.0524801,4.69119904 40.0045824,3.87531388 42.0616847,3.87531388 C43.7804915,3.8499933 45.0250938,4.20659139 45.9949233,4.57866316 L46.465804,4.79037129 L47.1782188,0.811524402",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1736222,12.210038 C54.6083097,11.1522007 56.2672869,7.07805 56.2672869,7.07805 C56.2362642,7.12693278 56.6986506,6.01528923 56.9641903,5.32600694 L57.3194744,6.9088945 C57.3194744,6.9088945 58.3254972,11.2911122 58.5360085,12.210038 L54.1736222,12.210038 Z M60.653679,0.377241388 L56.5930256,0.377241388 C55.3351278,0.377241388 54.3937358,0.703947129 53.8412358,1.89964091 L46.036804,18.7237557 L51.5547869,18.7237557 C51.5547869,18.7237557 52.4574006,16.4617844 52.6612642,15.9652199 C53.2643608,15.9652199 58.6250142,15.9729567 59.3913494,15.9729567 C59.548679,16.6154663 60.0306392,18.7237557 60.0306392,18.7237557 L64.9067472,18.7237557 L60.653679,0.377241388 L60.653679,0.377241388 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4585227,0.372950957 L13.3135511,12.8922165 L12.765483,10.3478505 C11.8078409,7.41488397 8.82375,4.23750359 5.48732955,2.64687919 L10.1917045,18.7022333 L15.7517898,18.6962548 L24.0248864,0.372950957 L18.4585227,0.372950957",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54085227,0.361627033 L0.0672159091,0.361627033 L0,0.743545694 C6.59269886,2.26313182 10.9547159,5.9356701 12.765483,10.3477801 L10.9229545,1.91145718 C10.6046023,0.749172488 9.68204545,0.402069617 8.54085227,0.361627033",
    id: "Fill-8"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcVisaLogoLight);
export default __webpack_public_path__ + "static/media/cc-visa-logo-light.9f968f2dc9a6692591d38ae2f90dc47c.svg";
export { ForwardRef as ReactComponent };